import styled from 'styled-components';
import { media } from '../../../components_desktop/css_global/utils.css';

const ButtonInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ bkgColor }) => bkgColor || 'white'};
  background-position: 94% center;
  background-repeat: no-repeat;
  background-size: 16px;
  border: ${({ border }) => border || '1px solid #000000'};
  border-radius: 5px;
  color: ${({ color }) => color || '#000000'};
  font: inherit;
  outline: none;
  overflow: hidden;
  padding: ${({ padding }) => padding || '8px 10px 5px 10px'};
  text-align: center;
  text-align-last: center;
  -moz-text-align-last: center;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
  min-height: 35px;
  ${({ isDesktop }) => (isDesktop ? 'cursor: pointer;' : null)}
  ${({ isDesktop }) => (isDesktop ? null : 'width: 100%;')}
  ${media['min-768']`
    height: 40px;
  `};
  ${({ width }) => (width ? `${width}px ` : null)}
  ${({ height }) => (height ? `${height}px ` : null)}
`;

export default ButtonInner;
